var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProntuario(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.75H16V17.25H8V18.75ZM8 15.75H16V14.25H8V15.75ZM12 11.9C13.0667 10.9333 13.9583 10.1167 14.675 9.45C15.3917 8.78333 15.75 8.03333 15.75 7.2C15.75 6.66818 15.558 6.21023 15.1739 5.82613C14.7898 5.44204 14.3318 5.25 13.8 5.25C13.3833 5.25 13.0417 5.32917 12.775 5.4875C12.5083 5.64583 12.25 5.88333 12 6.2C11.75 5.88333 11.4917 5.64583 11.225 5.4875C10.9583 5.32917 10.6167 5.25 10.2 5.25C9.66818 5.25 9.21023 5.44204 8.82613 5.82613C8.44204 6.21023 8.25 6.66818 8.25 7.2C8.25 8.03333 8.59583 8.77083 9.2875 9.4125C9.97917 10.0542 10.8833 10.8833 12 11.9ZM18.5 22H5.5C5.1 22 4.75 21.85 4.45 21.55C4.15 21.25 4 20.9 4 20.5V3.5C4 3.1 4.15 2.75 4.45 2.45C4.75 2.15 5.1 2 5.5 2H18.5C18.9 2 19.25 2.15 19.55 2.45C19.85 2.75 20 3.1 20 3.5V20.5C20 20.9 19.85 21.25 19.55 21.55C19.25 21.85 18.9 22 18.5 22ZM5.5 20.5H18.5V3.5H5.5V20.5Z",
    fill: "url(#paint0_linear_49_484)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_49_484",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D81C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2594BD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProntuario);
export default __webpack_public_path__ + "static/media/prontuario.b0bd809638968c4211442c3a2f300082.svg";
export { ForwardRef as ReactComponent };